(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/reducer.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/reducer.js');

const {
  UPDATE_ARTICLES,
  UPDATE_BILLING_INFORMATION,
  RECEIVE_COMPANY_DETAILS,
  CLEAR_STATE,
  ORDER_SUCCESS,
  UPDATE_REGISTER_INFORMATION
} = svs.ticket_partner.digitalTickets.actions;

const initialState = {
  partnerId: '',
  articles: {},
  billingInformation: {
    reference: '',
    address1: '',
    zip: '',
    city: '',
    message: '',
    email: '',
    invoiceMessage: '',
    countryId: 35,
    terms_and_conditions: false
  },
  registerNew: {
    companyName: '',
    organizationNumber: '',
    phone: '',
    contactPerson: '',
    eMail: '',
    cellPhone: ''
  },
  orderSuccess: false
};

svs.ticket_partner.digitalTickets.initialState = initialState;

svs.ticket_partner.digitalTickets.reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_ARTICLES:
      return {
        ...state,
        articles: {
          ...state.articles, [payload.articleId]: {
            ...payload
          }
        }
      };
    case UPDATE_BILLING_INFORMATION:
      return {
        ...state,
        billingInformation: {
          ...state.billingInformation, [payload.field]: payload.value
        }
      };
    case UPDATE_REGISTER_INFORMATION:
      return {
        ...state,
        registerNew: {
          ...state.registerNew, [payload.field]: payload.value
        }
      };
    case RECEIVE_COMPANY_DETAILS:
      return {
        ...state,
        partnerId: payload.partnerId,
        billingInformation: {
          ...state.billingInformation, ...payload
        }
      };
    case CLEAR_STATE:
      return {
        ...initialState
      };
    case ORDER_SUCCESS: {
      return {
        ...state,
        orderSuccess: true
      };
    }
    default:
      return state;
  }
};


 })(window);